import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";
import { DitlDoneButton } from "./DitlCardButtons";

const DitlCountCardContent = ({
  className = "tw-border-gray-10",
  count = null,
  title,
  description = null,
  descriptionVariant = "body-m",
  actions = null,
  onToggle,
  onDone = null,
}) => (
  <div
    className={`tw-flex tw-flex-col tw-w-full tw-overflow-hidden tw-bg-white tw-rounded-[12px] tw-border-[1px] tw-border-solid tw-shadow-[0px_2px_8px_0px_rgba(213,213,213,0.5)] ${className}`}
  >
    <button
      type="button"
      className="tw-flex tw-flex-col tw-gap-[8px] tw-w-full tw-px-[24px] tw-pt-[24px] tw-pb-[16px] tw-bg-transparent tw-border-0 tw-text-left tw-cursor-pointer"
      aria-expanded
      onClick={onToggle}
    >
      <Typography variant="headline2" component="span" className="tw-flex tw-gap-[8px]">
        {count != null && <span className="tw-text-[var(--brand)]">{count}</span>}
        {title}
      </Typography>
      {description && (
        <Typography variant={descriptionVariant} component="span" className="!tw-text-gray-50">
          {description}
        </Typography>
      )}
    </button>
    <div className="tw-flex tw-items-center tw-justify-between tw-px-[24px] tw-py-[16px] tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-t-[1px] tw-border-gray-10">
      {actions}
      <DitlDoneButton onClick={onDone} />
    </div>
  </div>
);

DitlCountCardContent.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionVariant: PropTypes.oneOf(["body-m", "body-s"]),
  actions: PropTypes.node,
  onToggle: PropTypes.func.isRequired,
  onDone: PropTypes.func,
};

export default DitlCountCardContent;
